import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e4c34a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-info" }
const _hoisted_2 = { class: "state" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查单号：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "责任人：", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对象类型：", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开始时间：", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "完成期限：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "被检查人签字：", -1))
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "当前状态：" + _toDisplayString(_ctx.detail.state_name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.detail.obj_name), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.detail.recheck_num_name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.detail.pool_name), 1),
          (_ctx.detail.history_lists.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: {"color":"#3d6eeb"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.QUALITY_ABOUT_DETAIL_HISTORY,
                query: {
                  id: _ctx.$route.query.id
                }
              })
            ))
              }, " 查看历史 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(_toDisplayString(_ctx.detail.orderid || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(_toDisplayString(_ctx.detail.liable_user_info.name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.detail.target_type_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(_toDisplayString(_ctx.detail.start_time_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createTextVNode(_toDisplayString(_ctx.detail.end_time_name || "-"), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['item', _ctx.detail.assign_pic.id != 0 && 'assgin'])
        }, [
          _hoisted_18,
          (_ctx.detail.assign_pic.id == '0')
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
            : (_openBlock(), _createBlock(_component_van_image, {
                key: 1,
                class: "img",
                src: _ctx.detail.assign_pic.photo_thumb_file,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickImage(_ctx.detail.assign_pic.photo_file)))
              }, null, 8, ["src"]))
        ], 2)
      ])
    ])
  ]))
}